import { render, staticRenderFns } from "./PerformanceSetting.vue?vue&type=template&id=9a475766&"
import script from "./PerformanceSetting.vue?vue&type=script&lang=js&"
export * from "./PerformanceSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports